import apiClient from './apiClient'
import { API_CONFIG } from './config'
import { mockDatabaseDetails, delay } from './mockData'

// Fetch database details by database name
const getDatabaseDetails = async (databaseName) => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: database details for', databaseName)
    return delay(mockDatabaseDetails[1])
  }
  
  const response = await apiClient.get(`/Databases/name/${databaseName}`)
  return response.data
}

// Legacy method for backward compatibility
const getDatabaseDetailsByAppId = async (applicationId) => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: database details', applicationId)
    return delay(mockDatabaseDetails[applicationId] || mockDatabaseDetails[1])
  }
  
  const response = await apiClient.get(`/Databases/application/${applicationId}`)
  return response.data
}

// Fetch database objects by server name, database name, and object type
const getDatabaseObjects = async (serverName, databaseName, objectType) => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: database objects', { serverName, databaseName, objectType })
    return delay([
      {
        routine_name: 'sp_GetUser',
        routine_schema: 'dbo',
        routine_type: 'PROCEDURE',
        created: '2024-01-15',
        last_altered: '2024-06-20',
      },
    ])
  }
  
  const response = await apiClient.get(`/Databases/objects`, {
    params: {
      serverName,
      databaseName,
      objectType,
    },
  })
  return response.data
}

const databaseService = {
  getDatabaseDetails,
  getDatabaseDetailsByAppId,
  getDatabaseObjects,
}

export default databaseService
